export default "__VITE_ASSET__U5GQ9oPC__"